/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import axios from 'axios';
import { getUrl } from '../utils/helper';
import {
	extractRawNotifications,
	normalizeNotification,
	NotificationCard,
	RawNotification,
} from '../types/notification/Notification';

export class NotificationService {
	/**
	 * Queries Strapi for notification entries and normalizes the payload for the UI.
	 * @param token Optional auth token forwarded to Strapi when available.
	 * @returns Normalized notification cards.
	 * @author Julien Tietke <j.tietke@tj-labs.de>
	 */
	public getNotifications(token?: string): Promise<NotificationCard[]> {
		return axios
			.get(`${getUrl()}/notifications`, {
				headers: token
					? {
							Authorization: `Bearer ${token}`,
						}
					: undefined,
			})
			.then((response) => {
				console.log('response', response.data);
				return this.mapResponse(response.data);
			});
	}

	/**
	 * Maps Strapi's response format to consumable notification cards.
	 * @param payload Any response payload returned by Strapi.
	 * @returns Clean list of notification cards.
	 * @author Julien Tietke <j.tietke@tj-labs.de>
	 */
	private mapResponse(payload: unknown): NotificationCard[] {
		const rawEntries: RawNotification[] = extractRawNotifications(payload);

		return rawEntries
			.map((entry) => normalizeNotification(entry))
			.filter((entry): entry is NotificationCard => Boolean(entry));
	}
}
